import React from 'react';

import {useAppSelector} from '../state/hooks';
import * as log from '../util/log';
import {Title} from '../components/ui/typography';
import {useToast} from '../components/ui/toast';

/**
 * Home screen to display when no chat is highlighted.
 */
export const ChatHome = () => {
  const {showToast} = useToast();
  const userId = useAppSelector((state) => state.auth.userId);

  if (!userId) {
    log.error('Trying to show home screen to an unknown user!');
    showToast('Your app is in a bad state, logging you out ...', 'error');
    window.location.pathname = '/logout';
    return null;
  }

  return (
    <div
      id="nudge-home-window"
      className="flex flex-col items-center justify-center h-full w-full p-8"
    >
      <div className="text-center space-y-4">
        <Title level={3} className="text-2xl font-bold">
          Hi, welcome to Nudge!
        </Title>
        <p className="text-muted-foreground">
          Click on a chat thread to the left to get started.
        </p>
      </div>
    </div>
  );
};
